import { useEffect, useState } from 'react';

/**
 * Tracks the browser's network connectivity state.
 * Returns true when online, false when offline.
 * Uses navigator.onLine as the initial value and subscribes to the browser's
 * online/offline events for subsequent changes.
 */
const useNetworkStatus = (): boolean => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return isOnline;
};

export default useNetworkStatus;
